<template>
    <div class="scroll">
        <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/logo.svg" alt="" class="logo">
        <div class="blocks">
            <div class="bar">
                <div class="car" v-if="progress < 100" :style="{ 'left': progress - 5 + '%' }">
                    <img class="roll1" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/1.png" alt="">
                    <img class="roll2" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/2.png" alt="">
                </div>
                <p v-for="(item, index) in 25" :key="index">
                    <img class="icon1" v-if="index < (progress / 4)" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/2.png" alt="">
                    <img class="icon1" v-else src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/1.png" alt="">
                </p>
            </div>
            <div class="progres">{{ progress }}%</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'app',
    data() {
        return {
            progress: 0,
        }
    },
    created() {
        /*  localStorage.setItem("nissan2023_meeting_openid", 'oSctw6KXxC3oEPm_J6DmDD2H_9bo')
         localStorage.setItem("nissan2023_meeting_mobile", 18515219892)
         localStorage.setItem("nissan2023_meeting_name", '小田')
         localStorage.setItem("nissan2023_meeting_cover", 'https://thirdwx.qlogo.cn/mmopen/vi_32/0EZI6n06WsEoLxdSwzqeQqvT8notpfeCUfMibokV7Bh2rquVPrNa1fQBjbuEWYk5yW6kUuEXaPWXlSOVibrHIg2g/132')
         localStorage.setItem("nissan2023_meeting_user", '{"token":"43b53610-7d9e-11ec-aff4-b9fbf79e5434","health_questionnaire":1,"meeting_questionnaire":1}'); */

        const that = this;
        that.timer = setInterval(function () {
            that.progress++;
            if (that.progress >= 100) {
                clearInterval(that.timer);
                that.timer = null;
                setTimeout(() => {
                    that.$nextTick(() => {
                        let mobile = localStorage.getItem('nissan2023_meeting_mobile');
                        if (mobile == "" || mobile == null) {
                            that.$router.replace('/login').catch(err => err);
                        } else {
                            that.$router.replace('/menu').catch(err => err);
                        }
                        /* if (openid == "" || openid == null || openid == undefined) {
                            that.axios.get("https://nissan.event1.cn/api2/wechat/getAppid").then(res => {
                                that.app_id = res.data.data.app_id;
                                local = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + res.data.data.app_id + "&redirect_uri=" + url + "&response_type=code&scope=snsapi_userinfo#wechat_redirect";
                                if (code == null || code == '') {
                                    location.href = local;
                                } else {
                                    that.axios.get("https://nissan.event1.cn/api2/wechat/getOauthUser", {
                                        params: {
                                            code: code
                                        }
                                    }).then(res => {
                                        let datas = res.data;
                                        if (datas.code == 1) {
                                            openid = datas.openid;
                                            localStorage.setItem("nissan2023_meeting_openid", datas.data.openid)
                                            localStorage.setItem("nissan2023_meeting_name", datas.data.nickname)
                                            localStorage.setItem("nissan2023_meeting_cover", datas.data.portrait)
                                            if (mobile == "" || mobile == null) {
                                                that.$router.replace('/login').catch(err => err);
                                            } else {
                                                that.$router.replace('/menu').catch(err => err);
                                            }
                                        }
                                    })
                                }
                            })
                        } else {
                            openid = localStorage.getItem("nissan2023_meeting_openid");
                            if (mobile == "" || mobile == null) {
                                that.$router.replace('/login').catch(err => err);
                            } else {
                                that.$router.replace('/menu').catch(err => err);
                            }
                        } */
                    });
                }, 500);
            }
        }, 15);
    },
    methods: {
        isMobile() {
            let flag = navigator.userAgent.match( // match方法可在字符串内检索指定的值，
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            return flag;
        },
        getUrlKey(name) { //获取url 参数
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
        },
    },
}
</script>
<style scoped>
.scroll {
    width: 100%;
    height: 100%;
    background: url(https://oss.eventnet.cn/H5/Nissan_meeting/2024/bg2.jpg?v=12190955) no-repeat;
    background-size: 100%;
    background-position: center bottom;
    position: relative;
}

.bar {
    display: flex;
    width: 100%;
    height: .3rem;
    position: relative;
}

.logo {
    position: absolute;
    width: 2.46rem;
    height: 1.28rem;
    left: 50%;
    transform: translateX(-50%);
    top: 2.7rem;
    z-index: 10;
}

.icon1 {
    width: .25rem;
    height: .35rem;
    margin-left: -.015rem;
    display: block;
}

.blocks {
    width: 100%;
    height: 1.87rem;
    background: #17aba2;
    position: absolute;
    left: 0;
    bottom: 7.05rem;
    padding-top: .7rem;
    padding-left: .7rem;
}

.progres {
    width: 100%;
    text-align: center;
    font-size: .26rem;
    color: #fff;
    position: absolute;
    bottom: .25rem;
    left: 0;
}

.car {
    width: 1.85rem;
    height: .59rem;
    background: url(https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/car.png) no-repeat;
    background-size: 100%;
    background-position: center top;
    position: absolute;
    bottom: -.05rem;
}

.roll1 {
    width: .27rem;
    height: .27rem;
    position: absolute;
    bottom: 0;
    left: .24rem;
    animation: rotate 2s linear infinite;
}

.roll2 {
    width: .27rem;
    height: .27rem;
    position: absolute;
    bottom: 0;
    left: 1.38rem;
    animation: rotate 2s linear infinite;
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Home.vue